module.exports = __webpack_public_path__ + "static/media/privacyPolicyPWA.2c6a5770.md";